import { render, staticRenderFns } from "./pgsignIndex.vue?vue&type=template&id=43ad4a42&"
import script from "./pgsignIndex.vue?vue&type=script&lang=js&"
export * from "./pgsignIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports